import React, { useCallback } from 'react';
import { InvoiceItem } from '../../../types/dashboard';
import SvgIcon from '../../utils/SvgIcon';
import PayInvoiceBtn from '../../PortalListing/components/PayInvoiceBtn';

type ResultsProps = Readonly<{
  invoices: InvoiceItem[];
  invoicePageUrl: string;
  showViewAll: boolean;
  payUrl: string;
  labels: Record<string, string>;
}>;

export default function InvoiceResults({ invoices, invoicePageUrl, showViewAll, payUrl, labels }: ResultsProps) {
  const formatDateLabel = useCallback((dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }, []);

  return (
    <div className="dashboard-invoices__results">
      <p className="dashboard-invoices__results-title">{labels.invoiceSubtitle}</p>
      <ul className="dashboard-invoices__results-list">
        {invoices.slice(0, 3).map(invoice => (
          <li key={invoice.guid} className="dashboard-invoice">
            <div className="dashboard-invoice__content">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/api/downloads/invoice/${invoice.guid}`}
                className="dashboard-invoice__name dashboard-invoices__link"
                title={`Download Invoice ${invoice.number}.pdf`}
              >
                <SvgIcon iconName="page" className="dashboard-invoice__icon" />
                <span className="dashboard-invoice__number">{invoice.number}.pdf</span>
              </a>
              <div className="dashboard-invoice__metadata">
                <span className="dashboard-invoice__meta">Due: {formatDateLabel(invoice.dateDue)}</span>
                <span className="dashboard-invoice__meta">Total: £{invoice.total}</span>
              </div>
            </div>
            <PayInvoiceBtn
              invoiceId={invoice.guid}
              invoiceNumber={invoice.number}
              dateDue={invoice.dateDue}
              amount={invoice.total}
              invoicePaymentUrl={payUrl}
              payButtonLabel={labels.payButtonLabel}
            />
          </li>
        ))}
      </ul>

      {invoices.length > 3 && showViewAll ? (
        <p className="dashboard-invoices__outstanding-info">
          <span>
            {invoices.length - 3} {labels.invoiceOtherOutstanding}
          </span>
          <a className="dashboard-invoices__link" href="/invoices/?Status=overdue">
            View all
          </a>
        </p>
      ) : (
        <a href={invoicePageUrl} className="dashboard-invoices__link">
          {labels.invoiceHistory}
        </a>
      )}
    </div>
  );
}
